import { DataGrid, GridColDef, GridSelectionModel } from '@mui/x-data-grid';
import { CircularProgress } from '@mui/material';
import { Item } from '../../utils/sharedTypes';
import { useFindAllRmasQuery } from '../../api/api-hooks';
import { Order, Rma } from '../../api/api-generated';
import { useHardwareTypeMap } from '../../hooks/useHardwareTypeMap';
import { RmaItemFilter } from './RmaTypes';
import { filterRmas } from './RmaUtils';

interface Props {
  setSelectedRmas: React.Dispatch<React.SetStateAction<Item[]>>;
  extraFilters?: {
    order?: Order;
    excludeOrder?: boolean;
  };
  filters?: RmaItemFilter;
}

const RmaTableCondensed = ({
  setSelectedRmas,
  extraFilters,
  filters,
}: Props) => {
  const { data: rmas } = useFindAllRmasQuery({});
  const typeMap = useHardwareTypeMap();
  if (rmas === undefined || typeMap === undefined) return <CircularProgress />;
  // Define data for display in DataGrid
  const columns: GridColDef[] = [
    { field: 'id', hide: true },
    { field: 'nameId', headerName: 'RMA #', width: 180 },
    { field: 'company', headerName: 'Company Name', width: 180 },
    { field: 'serial', headerName: 'Serial', width: 120 },
    { field: 'analyzerType', headerName: 'Analyzer Type', width: 200 },
    { field: 'status', headerName: 'Shipping', width: 135 },
    { field: 'isRepaired', headerName: 'Repaired', width: 145 },
    { field: 'repairPrice', headerName: 'Repair Price', width: 160 },
  ];
  const rows = rmas
    .filter((item: Rma) => {
      if (
        extraFilters?.order &&
        item.orderId === extraFilters.order.id &&
        extraFilters.excludeOrder
      )
        return false;
      return (
        filterRmas(item, filters) &&
        !(
          extraFilters?.order &&
          item.orderId !== extraFilters.order.id &&
          !extraFilters.excludeOrder
        )
      );
    })
    .map((item: Rma) => ({
      ...item,
      company: item.company.companyName,
      analyzerType: item.hardware
        ? typeMap.get(item.hardware.hardwareTypeId)
        : 'None',
      isRepaired: item.isRepaired ? 'Yes' : 'No',
    }));
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedRmas(rmas.filter((rma: Rma) => model.includes(rma.id)));
  };
  return (
    <div style={{ paddingBottom: '1rem', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={100}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
        disableColumnMenu={true}
        onSelectionModelChange={handleTableSelection}
      />
    </div>
  );
};

export default RmaTableCondensed;
